import styled from 'styled-components';
import { caption, colors, spacing, subtitle2 } from 'ui/theme';

export const JourneyContainer = styled.div`
  display: flex;
  padding: ${spacing.half} ${spacing.threeQuarter};
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.half};
  border-bottom: 1px solid ${colors.borderPrimarySubtle};
`;

export const JoureyConversionWrapper = styled.div`
  display: flex;
  cursor: pointer;
  padding: ${spacing.half};
  align-items: flex-start;
  gap: ${spacing.half};

  &:hover {
    border-radius: ${spacing.threeEights};
    outline: 1px solid ${colors.borderPrimarySubtle};
    background: ${colors.backgroundPrimary};
  }
`;

export const JourneyConversionTitle = styled.div`
  align-self: stretch;
  overflow: hidden;
  color: ${colors};
  text-overflow: ellipsis;
  ${subtitle2}
`;

export const JourneyConversionAdded = styled.div`
  color: ${colors.textDisabled};
  ${caption}
`;
